import React from 'react';
import FilterToggleButton from './FilterToggleButton';

type Props = {
	filterMenu: boolean;
	setFilterMenu: (value: boolean) => void;
	color?: 'green' | 'blue' | 'brown';
};

const AddFilterButton: React.FC<Props> = ({filterMenu, setFilterMenu, color = 'green'}) => {
	return (
		<FilterToggleButton
			isActive={filterMenu}
			onClick={() => setFilterMenu(!filterMenu)}
			variant={color}
		/>
	);
};

export default AddFilterButton;
